import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { FOREIGN_TRADE_BY_COUNTRIES_ACTIONS_NAME } from '@/modules/ved/store/foreignTradeByCountries/name';

import { TForeignTradeByCountriesFilter } from '../../types/foreign-trade-by-countries';
import { TForeignTradeByCountriesState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function searchCountryAggregated(
  context: ActionContext<TForeignTradeByCountriesState, unknown>,
  payload: TBaseFilterPayload<TForeignTradeByCountriesFilter>,
) {
  return request(
    context,
    {
      url: links.ved.foreignTrade.countries.getCountryAggregated,
      name: getLocalState(FOREIGN_TRADE_BY_COUNTRIES_ACTIONS_NAME.searchCountryAggregated),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
